import { clear, getTool, readUrl } from './tool-url';

const toolUrl = { clear, getTool, readUrl };

export default toolUrl;
